import { useContext } from 'react';
import { ConfigProvider } from 'antd';
import type { ExportThemeConfig } from '@/components/pdfExport/theme/exportThemeConfig';

function usePdfExportMode(): boolean {
  const configContext = useContext(ConfigProvider.ConfigContext);
  return Boolean((configContext?.theme as ExportThemeConfig | undefined)?.pdfFormat);
}

export { usePdfExportMode };
